export const cguStore = {
    namespaced: true,
    state: {
        seen: true,
        shown: false
    },

    getters: {
        getCguStatus: state => state.seen,
        getShown: state => state.shown
    },

    mutations: {
        SET_CGU_STATUS: (state, status) => {
            state.seen = status;
        },
        SET_SHOWN: (state, shown) => {
            state.shown = shown;
        }
    },

    actions: {
        setCguStatus: (context, data) => {
            context.commit("SET_CGU_STATUS", data);
        },
        setShown: (context, data) => {
            context.commit("SET_SHOWN", data);
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/cguStore/cguStore.js